import { Injectable } from '@angular/core';
import { DomService } from './dom.service';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  private readonly AUTH_COOKIE_PATTERNS = [
    'auth',
    'token',
    'session',
    'access_token',
    'refresh_token',
    'bearer',
    '.AspNetCore',
  ];

  private readonly CONSENT_COOKIE_PATTERNS = [
    'cookiebot',
    'cookieconsent',
    'cookie_consent',
    'gdpr',
    'consent',
    'CookieConsent',
  ];

  constructor(private dom: DomService) {}

  clearAll(): void {
    if (!this.dom.isBrowser || !this.dom.document) {
      return;
    }
    const cookies = this.dom.document.cookie.split(';');
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
      this.deleteCookie(name);
    }
  }

  clearAuthCookies(): void {
    if (!this.dom.isBrowser || !this.dom.document) {
      return;
    }
    const cookies = this.dom.document.cookie.split(';');
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

      if (this.isAuthCookie(name) && !this.isConsentCookie(name)) {
        this.deleteCookie(name);
      }
    }
  }

  private isAuthCookie(cookieName: string): boolean {
    const lowerName = cookieName.toLowerCase();
    return this.AUTH_COOKIE_PATTERNS.some(pattern => lowerName.includes(pattern.toLowerCase()));
  }

  private isConsentCookie(cookieName: string): boolean {
    const lowerName = cookieName.toLowerCase();
    return this.CONSENT_COOKIE_PATTERNS.some(pattern => lowerName.includes(pattern.toLowerCase()));
  }

  private deleteCookie(name: string): void {
    this.dom.document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    this.dom.document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${this.dom.window?.location.hostname}`;
    this.dom.document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${this.dom.window?.location.hostname}`;
  }
}
